import { GENERATION_TOOL } from 'src/data/generationTool';
import { PROMPT_SUB_TEMPLATE_ID } from 'src/data/template';

// This key will be returned by AC if the prompt is invalid.
const AC_INVALID_PROMPT_INDICATION =
  'question_or_statement_without_direct_or_indirect_request_for_content_generation';

const GENERATION_TOOLS = [
  /* ##### Social ##### */
  GENERATION_TOOL.instagramCaption,
  GENERATION_TOOL.facebookPost,
  GENERATION_TOOL.tweet,
  GENERATION_TOOL.linkedinPost,
  GENERATION_TOOL.pinterestMixturePost,
  GENERATION_TOOL.youtubeMixturePost,
  /* ##### Ads ##### */
  GENERATION_TOOL.facebookMixtureAd,
  GENERATION_TOOL.pinterestMixtureAd,
  GENERATION_TOOL.twitterMixtureAd,
  GENERATION_TOOL.linkedinMixtureAd,
  GENERATION_TOOL.googleRSA,
  GENERATION_TOOL.googlePerformanceMaxAd,
  GENERATION_TOOL.googleAppAd,
  GENERATION_TOOL.googleDemandGenAd,
  GENERATION_TOOL.googleDisplayAd,
  GENERATION_TOOL.googleShoppingAd,
  GENERATION_TOOL.googleVideoAd,
  GENERATION_TOOL.outbrainAd,
  GENERATION_TOOL.taboolaAd,
  /* ##### Email ##### */
  GENERATION_TOOL.emailMixture,
];

export const PROMPT_TOOLS = Object.fromEntries(
  GENERATION_TOOLS.map((generationTool) => [
    `${generationTool}_general`,
    `${generationTool} #${PROMPT_SUB_TEMPLATE_ID}`,
  ])
);

export const INVALID_TOOLS = {
  [AC_INVALID_PROMPT_INDICATION]: 'This prompt is not supported',
};
